<script>
import options from './StafetRoundCounter.options'
export default options
</script>

<template>
  <div class="kb-stafet-round-counter kb-optimizely-forms">
    <div class="kb-stafet-round-counter__content-wrapper">
      <div class="kb-stafet-round-counter__content-wrapper-left">
        <h2 class="kb-stafet-round-counter__title">
          {{ getLabel('rounds-title') }} {{ rute.ruteName }}
          <span class="kb-stafet-round-counter__round-length-meters">
            {{ `(${metersFormatted} m)` }}
          </span>
        </h2>

        <div class="kb-stafet-round-counter__controls-wrapper">
          <div class="kb-selector kb-amount-selector">
            <div class="kb-selector__wrapper">
              <button
                @click="handleRemoveOneRound"
                class="kb-stafet-round-counter__controls-wrapper-input-button kb-stafet-round-counter__controls-wrapper-input-button--left"
              >
                <svg
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#a)">
                    <path d="M0 9.5v1h20v-1H0Z" fill="#3C3C3C" />
                  </g>
                  <defs>
                    <clipPath id="a">
                      <path fill="#fff" d="M0 0h20v20H0z" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <input
                @input="handleSetRoundCount"
                type="number"
                :id="rute.id"
                :value="amount.count"
                required="required"
              />
              <button
                @click="handleAddOneRound"
                class="kb-stafet-round-counter__controls-wrapper-input-button"
              >
                <svg
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#a)">
                    <path
                      d="M9.5 9.5H0v1h9.5V20h1v-9.5H20v-1h-9.5V0h-1v9.5Z"
                      fill="#3C3C3C"
                    />
                  </g>
                  <defs>
                    <clipPath id="a">
                      <path fill="#fff" d="M0 0h20v20H0z" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          </div>

          <button
            class="kb-button kb-button--full-color kb-stafet-round-counter__add-button"
            :disabled="shouldDisableApplyButton"
            @click="handleSubmit"
          >
            {{ getLabel('rounds-add-button-text') }}
          </button>
        </div>
      </div>

      <div class="kb-stafet-round-counter__content-wrapper-right">
        <ul class="kb-stafet-round-counter__round-details-list">
          <li class="kb-stafet-round-counter__round-details-list-item">
            <h3
              class="kb-stafet-round-counter__title kb-stafet-round-counter__round-details-title"
            >
              {{ getLabel('details-title-km') }}
            </h3>
            <p class="kb-stafet-round-counter__round-details-list-item-detail">
              {{ `${detailsKmFormatted} ${getLabel('details-suffix-km')}` }}
            </p>
          </li>
          <li class="kb-stafet-round-counter__round-details-list-item">
            <h3
              class="kb-stafet-round-counter__title kb-stafet-round-counter__round-details-list-item-title"
            >
              {{ getLabel('details-title-rounds') }}
            </h3>
            <p class="kb-stafet-round-counter__round-details-list-item-detail">
              {{ `${detailsRoundsFormatted} ${getLabel('details-suffix-rounds')}` }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
